
















import { Component, Prop, Vue } from 'vue-property-decorator';
import { DropDown, Carousel } from '@/pages/profile/components';
import { MenuCard } from './components';
import { MENU_TITLE, MENU_DESCRIPTION, MENU_HEIGHT } from './consts';
import { IMenu } from './types';

@Component({
  components: {
    DropDown,
    Carousel,
    MenuCard,
  },
})
export default class RemoteEduMenu extends Vue implements IMenu {
  @Prop({ type: Boolean, default: false })
  readonly alwaysOpen!: boolean;

  title = MENU_TITLE;
  description = MENU_DESCRIPTION;
  height = MENU_HEIGHT;
  menu: Array<string> = [
    'calendar',
    'webinars',
    'lessons',
    'tests',
    'examination',
  ];
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/profile/modules/remote-edu/remotemenu/RemoteEduMenu.vue